/* global gtag */
import React from "react";
import logo from "../assets/images/PPP.jpg";
import { ReactComponent as GlowingPlayIcon } from "../assets/images/start-btn-icon-glowing.svg";
import { ReactComponent as PlayIcon } from "../assets/images/start-btn-icon.svg";
import "../styles/StartScreen.css";
const StartScreen = ({
  header,
  score,
  current,
  currentQ,
  questions,
  isFlipping,
  handleStart,
}) => {
  return (
    <div className="start-container">
      <div className="content-box">
        <div className="content-box-header">
          <img src={header} />
        </div>
        <div className="headline-header">
          <div className="headline-header-left">{current.category}</div>
          <div className="headline-header-right">
            {new Date(current.publishedAt)
              .toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "numeric",
                year: "numeric",
              })
              .replace(/ /g, "-")}
          </div>
        </div>
        <div className="info-bar">
          <span className="info-bar-left">
            {score}/{questions.length}
          </span>
          <span className="info-bar-right">00:20</span>
        </div>
        <div key={currentQ} className={`flipper ${isFlipping ? "flip" : ""}`}>
          <div className="start-content">
            <img
              src={current.image}
              alt={`question-${currentQ}`}
              style={{ width: "17.5rem", height: "10rem", objectFit: "cover" }}
            />
          </div>
        </div>
      </div>
      <div className="start-bottom-container">
        <div className="start-question">
          Complete the headline with the correct word in 20 seconds.
        </div>
        <div className="start-question-text">{current.sentence}</div>
        <div className="start-play-btn-container">
          <button className="start-play-btn" onClick={handleStart}>
            <div className="icon-wrapper">
              <PlayIcon className="icon default-icon" />
              <GlowingPlayIcon className="icon glowing-icon" />
            </div>
            PLAY GAME
          </button>
        </div>

        <div className="ppp-logo">
          Powered by <img src={logo} alt="PPP Logo" width={20} height={20} />
        </div>
      </div>
    </div>
  );
};

export default StartScreen;
